import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { getAssetTypes } from '../../actions/AssetActionCreator';
import AssetTypeStore from '../../stores/AssetTypeStore';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import LinearProgress from 'material-ui/LinearProgress';

export const getFilter = (allowedTypes) => {
    if (!allowedTypes) { return () => true; }
    if (allowedTypes.length === 1) {
        const [type] = allowedTypes;
        return (t) => (!!t && t.name === type);
    }
    return (t) => (!!t && allowedTypes.includes(t.name));
};

class SelectAssetType extends Component {

    componentDidMount() {
        getAssetTypes();
        this.selectAssetType = this.selectAssetType.bind(this);
    }

    render() {
        if (!this.state) { return null; }
        if (this.state.assetTypes.length === 0 && this.state.isFetching) { return this.props.showLoadProgress ? <LinearProgress /> : null; }
        const list = (this.props.allowedTypes ? this.state.assetTypes.filter(getFilter(this.props.allowedTypes)) : this.state.assetTypes);
        return (
            <SelectField
                floatingLabelText={this.props.label}
                onChange={this.selectAssetType}
                fullWidth={this.props.fullWidth}
                value={this.props.value}
            >
                {list.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name}/>)}
            </SelectField>
        );
    }

    selectAssetType(e, index, id) {
        const type = this.state.assetTypes.find(t => !!t && t.id === id);
        this.props.onSelect && this.props.onSelect(type.id, type.name, type);
    }
}

SelectAssetType.getStores = () => ([AssetTypeStore]);
SelectAssetType.calculateState = (prevState) => ({
    ...AssetTypeStore.getState()
});

SelectAssetType.propTypes = {
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    fullWidth: PropTypes.bool,
    value: PropTypes.number,
    showLoadProgress: PropTypes.bool,
    allowedTypes: PropTypes.array,
};

SelectAssetType.defaultProps = {
    label: 'Asset type',
    fullWidth: true,
    showLoadProgress: true,
};


export default Container.create(SelectAssetType);
